import ViewTrainerAttendance from '../commonfile/ViewTrainerAttendance'

const CoordinatorViewTraAtd = () => {
    return (
        <ViewTrainerAttendance />
    )
}

export default CoordinatorViewTraAtd